// Distribution
import DistributionList from "@/components/Pages/distribution/DistributionList"
import DistributionListMembers from "@/components/Pages/distribution/DistributionListMembers"
import DistributionManager from "@/components/Pages/distribution/DistributionManager"

// Funds
import FundsPage from "@/components/Pages/funds/FundsPage"

import LandingSRsList from "@/components/Pages/repertoire/LandingSRsList"
import Logout from "@/components/Pages/Login/Logout"


// Members
import MemberDetail from "@/components/Pages/members/MemberDetail"
import MembersList from "@/components/Pages/members/MembersList"

import PermissionDenied from "@/components/Layout/PermissionDenied"

// Repertoire
import RepertoireFilesList from "@/components/Pages/repertoire/RepertoireFilesList"
import SelectedSoundRecordings from "@/components/Pages/repertoire/SelectedSoundRecordings"
import SoundRecordingDetailPage from "@/components/Pages/repertoire/SoundRecordingDetailPage"
import SoundRecordingsList from "@/components/Pages/repertoire/SoundRecordingsList"

// Usage
import UsageFilesPage from "@/components/Pages/usage/UsageFilesPage"
import UsagesPage from "@/components/Pages/usage/UsagesPage"

// User
import User from "@/components/Pages/User/User"
import UsersCreate from "@/components/Pages/members/UsersCreate"
import UsersDetail from "@/components/Pages/members/UsersDetail"
import UsersList from "@/components/Pages/members/UsersList"

import Vue from "vue"
import VueRouter from "vue-router"

// SignUp, Login and Logout
import Welcome from "@/components/Pages/Login/Welcome"

import { get } from "lodash"

import { isDefined } from "@/assets/libs/utils"

// store
import { store } from "@/store/store"

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: "history",
  routes: [
    // Login / Signup / Logout
    {
      path: "/welcome",
      name: "welcome",
      component: Welcome
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout,
    },
    // Current User
    {
      path: "/user",
      name: "user-info",
      component: User,
    },
    // Users
    {
      path: "/users",
      name: "users-list",
      component: UsersList,
    },
    {
      path: "/users/create",
      name: "users-create",
      component: UsersCreate,
    },
    {
      path: "/users/:id",
      name: "users-detail",
      component: UsersDetail,
      props: true,
    },
    // Members
    {
      path: "/members",
      name: "members-list",
      component: MembersList,
    },
    {
      path: "/members/:id",
      name: "members-detail",
      component: MemberDetail,
      props: true,
    },
    {
      path: "/members/:member_id/users",
      name: "members-users-list",
      component: UsersList,
      props: true,
    },
    {
      path: "/members/:id/users/create",
      name: "members-users-create",
      component: UsersCreate,
      props: true,
    },
    // Repertoire
    {
      path: "/repertoire/soundrecordings",
      name: "sound-recordings",
      component: SoundRecordingsList,
    },
    {
      path: "/repertoire/soundrecordings/:id",
      name: "sound-recording-from-db-detail",
      component: SoundRecordingDetailPage,
    },
    {
      path: "/landed/soundrecordings/:id",
      name: "sound-recording-from-landed-detail",
      component: SoundRecordingDetailPage,
    },
    {
      path: "/repertoire/files",
      name: "repertoire-files",
      component: RepertoireFilesList,
    },
    {
      path: "/repertoire/files/:id",
      name: "repertoire-file-detail",
      component: LandingSRsList,
    },
    {
      path: "/repertoire/claims",
      name: "claims",
      component: SelectedSoundRecordings,
    },
    // Usages
    {
      path: "/usages/soundrecordings/:id",
      name: "sound-recording-from-usages-detail",
      component: SoundRecordingDetailPage,
    },
    {
      path: "/playlist/uploads",
      name: "playlist-files",
      component: UsageFilesPage,
    },
    {
      path: "/playlist/usages/:id?",
      name: "usages",
      component: UsagesPage,
    },
    // Fundsa and Distribution
    {
      path: "/funds",
      name: "funds",
      component: FundsPage,
    },
    {
      path: "/distributions",
      name: "distributions",
      component: DistributionList,
    },
    {
      path: "/distributions-members",
      name: "distributions-members",
      component: DistributionListMembers,
    },
    {
      path: "/distribution/new",
      name: "distribution-create",
      component: DistributionManager,
    },
    {
      path: "/distribution/:id",
      name: "distribution-detail",
      component: DistributionManager,
      props: true
    },
    {
      path: "/permission-denied",
      name: "permission-denied",
      component: PermissionDenied,
    },
    {
      path: "*",
      name:"not-found",
      beforeEnter: (to, from, next) => {
        next("/repertoire/soundrecordings")}
    }
  ]
})


const routes = {
  open: ["welcome"],
  roles: ["members-list", "distributions", "funds","playlist-files", "usages"],
}

function openRoutes (name) {
  return routes.open.includes(name)
}

function checkPermission (routeName, role) {
  return !(role === "MEMBER" && routes.roles.includes(routeName))
}

router.beforeEach((to, from, next) => {
  // clean page not found status
  store.commit("soundsys/setPageNotFound", false)

  const { name, params, query } = to
  const page = get(query, "page")

  const listPages = [
    "distributions",
    "funds",
    "members-list",
    "repertoire-file-detail",
    "repertoire-files",
    "sound-recordings",
    "usages",
    "playlist-files",
  ]

  let userRole = localStorage.getItem("userRole")
  if(name==="permission-denied"){
    return next()
  }

  // User is authenticated and has role
  if (router.app.$auth.isAuthenticated() && isDefined(userRole)) {
    const hasPermission = checkPermission(to.name, userRole)

    // User has no permissions
    if (!hasPermission) {
      router.push({ name: "permission-denied" })
    // User tries to access open routes when authenticated
    } else if (openRoutes(to.name)) {
      router.push({ name: "sound-recordings", params, query: { ...query, page: 1 } })
    } else {
      if (!page && listPages.includes(name)) {
        return next({ name, params, query: { ...query, page: 1 } })
      }
      return next()
    }
  // User is not authenticated
  } else {
    // Store path for redirection after login
    let redirect = to.fullPath !== "/" ? to.fullPath : undefined
    store.commit("soundsys/setLogged", false)
    !openRoutes(to.name)
      ? next({ name: "welcome", query: { redirect } })
      : next()
  }
})

